module.exports = __webpack_public_path__ + "img/select.44e2d430.png";